'use strict';
var React = require('react');
var FormatMessage = require('react-globalize').FormatMessage;

var BfgNotice = React.createClass({ render: function() {
  return <section id="notice" className="content-section text-center notice-section">
    <div className="row">
    <div className="col-sm-2 col-xs-2"></div>
    <div className="col-sm-8 col-xs-8">

    <h3 className="text-center"><FormatMessage locale={this.props.locale} path="noticePage/title" /></h3><hr className="small"/>
    <FormatMessage locale={this.props.locale} path="noticePage/message1" />
    <h4><strong>1-800-926-2277 - Option 21</strong></h4>
      <FormatMessage locale={this.props.locale} path="noticePage/message2" /><br/>
      <h4><strong>TEXAS</strong></h4>
      <FormatMessage locale={this.props.locale} path="noticePage/message3" /><br/>
      <FormatMessage locale={this.props.locale} path="noticePage/personEmail" />(U.S Mail)......................................Texas Department of Banking<br/>
      2601 North Lamar Boulevard<br/>

      <p>Suite 300<br></br>
      Austin, TX 78705-4294</p><br/>
      <FormatMessage locale={this.props.locale} path="noticePage/phone" />.....................1-877/276-5554 <FormatMessage locale={this.props.locale} path="noticePage/tollFree" /><br/>
      <FormatMessage locale={this.props.locale} path="noticePage/fax" />.........................................512/475-1313<br/>
      <FormatMessage locale={this.props.locale} path="noticePage/email" />.......consumer.complaints@dob.texas.gov<br/>
      <FormatMessage locale={this.props.locale} path="noticePage/website" />............................www.dob.texas.gov<br/>


    <h4><strong>OKLAHOMA</strong></h4>
      <FormatMessage locale={this.props.locale} path="noticePage/oklahomaMessage" /><br/><br/>

      <strong><FormatMessage locale={this.props.locale} path="noticePage/address" /></strong> <i className="fa fa-map-marker"></i> Oklahoma Office of the State Banking Department<br/>
      2900 N. Lincoln Blvd<br/>
      Oklahoma City, OK 73105<br/>
      <FormatMessage locale={this.props.locale} path="noticePage/online" /><i className="fa fa-globe"></i><a href="https://www.osbd.state.ok.us" target="_blank"> www.osbd.state.ok.us</a><br/>
        <FormatMessage locale={this.props.locale} path="noticePage/phone" /> <i className="fa fa-phone"></i> 405-521-3921<br/><br/>

    <div className="row">
        <div className="col-md-4 col-sm-4 col-xs-12 text-left">

          <h4><strong>ALABAMA </strong></h4>
          <strong><FormatMessage locale={this.props.locale} path="noticePage/address" /></strong> <i className="fa fa-map-marker"></i> Alabama Securities Commission<br/>
        401 Adams Avenue, Suite 280<br/>
        Montgomery, AL 36104 <br/>
        <FormatMessage locale={this.props.locale} path="noticePage/online" /> <i className="fa fa-globe"></i><a href="http://www.bank.state.al.us" target="_blank"> www.bank.state.al.us </a><br/>
          <FormatMessage locale={this.props.locale} path="noticePage/phone" /> <i className="fa fa-phone"></i> 1-800-392-5658<br/>

        </div>
        <div className="col-md-4 col-sm-4 col-xs-12 text-left">

          <h4><strong>NEW MEXICO</strong></h4>
        <strong><FormatMessage locale={this.props.locale} path="noticePage/address" /></strong> <i className="fa fa-map-marker"></i> New Mexico Regulation & Licensing Department<br/>
        Financial Institutions Division<br/>
        2550 Cerrillos Road<br/>
        Santa Fe, NM 87504<br/>
        <FormatMessage locale={this.props.locale} path="noticePage/online" /> <i className="fa fa-globe"></i><a href="http://www.rld.state.nm.us" target="_blank"> www.rld.state.nm.us</a><br/>
          <FormatMessage locale={this.props.locale} path="noticePage/phone" /> <i className="fa fa-phone"></i> 1-800-678-1508<br/>

        </div>
        <div className="col-md-4 col-sm-4 col-xs-12 text-left">

          <h4><strong>MISSISSIPPI</strong></h4>
          <strong><FormatMessage locale={this.props.locale} path="noticePage/address" /></strong> <i className="fa fa-map-marker"></i> Mississippi Department of Banking & Consumer Finance<br/>
            Consumer Finance Division<br/>
            501 N. West St.<br/>
            901 Woolfolk Bldg., Suite A <br/>
            Jackson, MS 39225-3729<br/>
            <FormatMessage locale={this.props.locale} path="noticePage/online" /> <i className="fa fa-globe"></i><a href="http://www.dbcf.state.ms.us" target="_blank"> www.dbcf.state.ms.us</a><br/>
            <FormatMessage locale={this.props.locale} path="noticePage/phone" /> <i className="fa fa-phone"></i> 1-800-281-4418<br/>

        </div>
    </div>
      <div className="row">
          <div className="col-md-4 col-sm-4 col-xs-12 text-left">

          <h4><strong>GEORGIA </strong></h4>
          <strong><FormatMessage locale={this.props.locale} path="noticePage/address" /></strong> <i className="fa fa-map-marker"></i> Georgia Department of Banking and Finance<br/>
        2990 Brandywine Road Suite 200<br/>
        Atlanta, GA 30341<br/>
        <FormatMessage locale={this.props.locale} path="noticePage/online" /> <i className="fa fa-globe"></i><a href="https://dbf.georgia.gov" target="_blank"> www.dbf.georgia.gov </a><br/>
          <FormatMessage locale={this.props.locale} path="noticePage/phone" /> <i className="fa fa-phone"></i> 404-651-8600<br/>

          </div>
          <div className="col-md-4 col-sm-4 col-xs-12 text-left">

          <h4><strong>ARKANSAS</strong></h4>
          <strong><FormatMessage locale={this.props.locale} path="noticePage/address" /></strong> <i className="fa fa-map-marker"></i> Arkansas Securities Department<br/>
        201 E. Markham, Suite 300<br/>
        Little Rock, AR 72201-1692<br/>
        <FormatMessage locale={this.props.locale} path="noticePage/online" /> <i className="fa fa-globe"></i><a href="http:// www.securities.arkansas.gov" target="_blank">  www.securities.arkansas.gov</a><br/>
          <FormatMessage locale={this.props.locale} path="noticePage/phone" /> <i className="fa fa-phone"></i> 1-800-482-8982<br/>

          </div>
          <div className="col-md-4 col-sm-4 col-xs-12 text-left">

          <h4><strong>LOUISIANA</strong></h4>
          <strong><FormatMessage locale={this.props.locale} path="noticePage/address" /></strong> <i className="fa fa-map-marker"></i> Louisiana Office of Financial Institutions<br/>
        Depository Division<br/>
        8660 United Plaza Blvd., 2nd Floor<br/>
        Baton Rouge, LA 70809-7024<br/>
        <FormatMessage locale={this.props.locale} path="noticePage/online" /> <i className="fa fa-globe"></i><a href="http://www.ofi.louisiana.gov" target="_blank"> www.ofi.louisiana.gov</a><br/>
          <FormatMessage locale={this.props.locale} path="noticePage/phone" /> <i className="fa fa-phone"></i> 1-800-351-4889<br/>

          </div>

      </div>
    </div>
    </div>
    </section>

}
})

module.exports = BfgNotice




// WEBPACK FOOTER //
// ./js/notice.js